function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 21555",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17745",
    d: "M12.75 8.5h-.007m-2.993 0h-.008m-2.992 0h-.008M12 13h3a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 15 4H4.5A1.5 1.5 0 0 0 3 5.5v6A1.5 1.5 0 0 0 4.5 13h3.75L12 16.75Z",
    transform: "translate(-.5 -1.5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19935",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }));
};

export default SvgComment;